export interface SocialCategoryOption {
  value: string;
  labelKey: string;
}

export const SOCIAL_CATEGORY_OPTIONS: SocialCategoryOption[] = [
  { value: "disability_1", labelKey: "disability_1" },
  { value: "disability_2", labelKey: "disability_2" },
  { value: "disability_3", labelKey: "disability_3" },
  { value: "child_disability", labelKey: "child_disability" },
  { value: "veteran", labelKey: "veteran" },
  { value: "orphan", labelKey: "orphan" },
  { value: "large_family", labelKey: "large_family" },
];

